import React, { useState, useEffect, useRef } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import { styled } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import TextField from '@mui/material/TextField';
import LeadService from '../../../core/services/leadsService';
import { useDropzone } from 'react-dropzone';
import toast from 'react-hot-toast';
import Chip from '@mui/material/Chip';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
const names = [
    'Oliver Hansen',
    'Van Henry',
    'April Tucker',
    'Ralph Hubbard',
    'Omar Alexander',
    'Carlos Abbott',
    'Miriam Wagner',
    'Bradley Wilkerson',
    'Virginia Andrews',
    'Kelly Snyder',
];

const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`,
}));
const ICAEditProfile = ({ handleOpenICAProfile }) => {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [bio, setBio] = useState('');
    const [phone, setPhone] = useState();
    const [last_name, setLast_name] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);
    const [user, setUser] = useState('');
    const [imageShow, setImageShow] = useState(null);
    const [personName, setPersonName] = React.useState([]);
    const [selectedImage, setSelectedImage] = useState(null);

    const handleClose = () => {
        setOpen(false);
        setSelectedImage(null);
    };
    const handleOpen = () => {
        setOpen(true);
    };

    const handleGetProfile = async () => {
        try {
            const res = await LeadService.ICAProfile();
            if (res?.data?.success) {
                setUser(res?.data?.user);
                setImageShow(res?.data?.user?.profile_image);
                return;
            }
        } catch (error) {
            console.error(error.message);
        }
    };
    useEffect(() => {
        handleGetProfile();
    }, []);

    useEffect(() => {
        if (user) {
            setName(user.name);
            setLast_name(user.last_name);
            setPhone(user.phone);
            setEmail(user.email);
            setBio(user.bio);
        }
    }, [user]);
    const handleNameChange = (event) => {
        setName(event.target.value);
    };
    const handleLastNameChange = (event) => {
        setLast_name(event.target.value);
    };
    const handlePhoneChange = (event) => {
        let inputValue = event.target.value.replace(/\D/g, '');
        if (inputValue.length > 10) {
            inputValue = inputValue.slice(0, 10);
        }
        setPhone(inputValue);
    };

    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    const handleBioChange = (event) => {
        setBio(event.target.value);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');
        try {
            setLoading(true);
            const values = { name, email, selectedImage, phone, last_name, bio };
            const response = await LeadService.editICAProfile(values);
            if (response?.data?.success === true) {
                await handleOpenICAProfile();
                toast.success(response?.data?.message);
                setOpen(false);
                return;
            }
        } catch (err) {
            setError(err.message);
            console.error('Error updating profile:', err);
            toast.error(err.message);
        } finally {
            setLoading(false);
        }
    };
    // const handleChange = (event) => {
    //     const {
    //         target: { value },
    //     } = event;
    //     setPersonName(typeof value === 'string' ? value.split(',') : value);
    // };

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('image/')) {
            const reader = new FileReader();
            reader.onload = () => {
                setSelectedImage(reader.result);
            };
            reader.readAsDataURL(file);
        } else {
            alert('Please select a valid image file.');
        }
    };
    return (
        <div>
            <Chip onClick={handleOpen} label="Edit Profile" />

            <Dialog open={open} aria-labelledby="edit-profile-dialog-title" maxWidth="sm" fullWidth>
                <DialogTitle id="edit-profile-dialog-title">
                    Edit Profile
                    <IconButton
                        aria-label="close"
                        onClick={handleClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <Badge
                            overlap="circular"
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                            badgeContent={
                                <IconButton
                                    color="primary"
                                    component="label"
                                    sx={{
                                        backgroundColor: 'white',
                                        '&:hover': { backgroundColor: 'lightgray' },
                                    }}
                                >
                                    <AddIcon />
                                    <input type="file" accept="image/*" hidden onChange={handleImageChange} />
                                </IconButton>
                            }
                        >
                            <Avatar
                                src={selectedImage ? selectedImage : imageShow ? `https://iconnctapp.com/${imageShow}` : '/default-avatar.png'}
                                sx={{ width: 100, height: 100 }}
                            />
                        </Badge>
                    </Box>
                    <Box sx={{ textAlign: 'center', mt: 1 }}>
                        <Typography variant="body2" color="textSecondary">
                            Change photo
                        </Typography>
                    </Box>
                    <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
                        <TextField
                            fullWidth
                            label="First Name"
                            value={name}
                            onChange={handleNameChange}
                            margin="normal"
                            onKeyDown={(event) => {
                                event.stopPropagation();
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Last Name"
                            value={last_name}
                            onChange={handleLastNameChange}
                            margin="normal"
                            onKeyDown={(event) => {
                                event.stopPropagation();
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Phone Number"
                            value={phone}
                            onChange={handlePhoneChange}
                            margin="normal"
                            inputProps={{ maxLength: 10 }}
                            onKeyDown={(event) => {
                                event.stopPropagation();
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Email"
                            value={email}
                            onChange={handleEmailChange}
                            margin="normal"
                            InputProps={{
                                readOnly: true,
                            }}
                            onKeyDown={(event) => {
                                event.stopPropagation();
                            }}
                        />
                        <TextField
                            fullWidth
                            label="Bio"
                            value={bio}
                            onChange={handleBioChange}
                            margin="normal"
                            multiline
                            onKeyDown={(event) => {
                                event.stopPropagation();
                            }}
                            row={2}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'center' }}>
                    <Button
                        type="submit"
                        disabled={loading}
                        onClick={handleSubmit}
                        variant="contained"
                        color="primary"
                        sx={{
                            width: '100%',
                            m: 1,
                            height: '50px', // Adjust the height as needed
                            fontSize: '16px', // Adjust the font size as needed
                            px: 4, // Horizontal padding
                        }}
                    >
                        {loading ? 'Loading...' : 'Save'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};
export default ICAEditProfile;
